import React from 'react';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface YearRangeSliderProps {
    min: number;
    max: number;
    value: number[];
    onChange: (event: Event, newValue: number | number[]) => void;
    onChangeCommitted?: (event: Event | React.SyntheticEvent<Element, Event>, newValue: number | number[]) => void;
    label?: string;
}

export default function YearRangeSlider({ min, max, value, onChange, onChangeCommitted, label = "Year range" }: YearRangeSliderProps) {
    return (
        <Box sx={{ width: '100%', px: 1 }}>
            <Typography id="year-range-slider" gutterBottom variant="caption" color="textSecondary">
                {label}
            </Typography>
            <Slider
                getAriaLabel={() => label}
                value={value}
                onChange={onChange}
                onChangeCommitted={onChangeCommitted}
                valueLabelDisplay="auto"
                min={min}
                max={max}
                disableSwap
                marks={[
                    { value: min, label: min.toString() },
                    { value: max, label: max.toString() }
                ]}
            />
        </Box>
    );
}
